import { atom } from 'recoil';
import { ICompetencia } from '../../commons/types/programa';


export const competenciasAtom = atom<ICompetencia[]>({
  key: 'competencias', 
  default: [] as ICompetencia[],
}); 
